import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { obtenerArticuloPorId, incrementarVistas } from '../../services/articuloService';
import './ArticuloDetalle.css';

const ArticuloDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [articulo, setArticulo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarArticulo();
  }, [id]);

  const cargarArticulo = async () => {
    try {
      setLoading(true);
      const data = await obtenerArticuloPorId(id);
      if (!data) {
        navigate('/blog');
        return;
      }
      setArticulo(data);
      await incrementarVistas(id);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatearFecha = (fecha) => {
    return fecha?.toLocaleDateString('es-CO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) return <div className="loading">Cargando articulo...</div>;
  if (!articulo) return <div className="error">Articulo no encontrado</div>;

  return (
    <div className="articulo-detalle-container">
      <div className="articulo-detalle-header">
        <Link to="/blog" className="btn-volver-blog">
          ← Volver al Blog
        </Link>
      </div>

      <article className="articulo-detalle">
        <div className="articulo-categoria">{articulo.categoria}</div>
        <h1>{articulo.titulo}</h1>
        <div className="articulo-meta">
          <span>{formatearFecha(articulo.fechaPublicacion)}</span>
          <span>{articulo.vistas || 0} vistas</span>
        </div>
        <div className="articulo-contenido">
          {articulo.contenido?.split('\n').map((parrafo, index) => (
            <p key={index}>{parrafo}</p>
          ))}
        </div>
      </article>

      <div className="articulo-footer">
        <p className="articulo-nota">
          Este articulo tiene caracter informativo y no constituye asesoria legal.
          Para casos especificos, contacta a nuestros abogados.
        </p>
        <Link to="/asesoria" className="btn-asesoria">
          Solicitar Asesoria Legal
        </Link>
      </div>
    </div>
  );
};

export default ArticuloDetalle;